import config from "@/config"
import http from "@/utils/request"

export default {
    sponsoredProduct: {
        getSpendPageList: {
            url: `${config.API_URL}/api/app/sponsored-product-report/page-list`,
            name: "获取广告费用分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        exportSpendList: {
            url: `${config.API_URL}/api/app/sponsored-product-report/export`,
            name: "广告费发票导出",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        },
    }
}